module.exports = __webpack_public_path__ + "static/media/bliss_truck_start.71aa4c45.png";